import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo: null,
    pageKey: [],
    pageTitle: "",
    loadingShow: false,
  },
  getters: {
    userInfo: (state) => state.userInfo,
    pageKey: (state) => state.pageKey,
    pageTitle: (state) => state.pageTitle,
    loadingShow: (state) => state.loadingShow,
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setPageKey(state, data) {
      state.pageKey = data;
    },
    setPageTitle(state, data) {
      state.pageTitle = data;
    },
    setLoading(state, data) {
      state.loadingShow = data;
    },
  },
  actions: {
    setUserInfo({ commit }, data) {
      commit("setUserInfo", data);
    },
    setPageKey({ commit }, data) {
      commit("setPageKey", data);
    },
    setPageTitle({ commit }, data) {
      commit("setPageTitle", data);
    },
    setLoading({ commit }, data) {
      commit("setLoading", data);
    },
  },
  modules: {
  }
})
